import { useCallback, useState } from 'react';
import { Button, CloseFullscreenIcon, ExitAppIcon, OpenInFullIcon, SetUpIcon } from 'tuui';
import { POST_MESSAGES_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { STEP_IDS } from '../../config/stepIds';
import styles from './headerCodeless.module.scss';

export const HeaderCodeless = ({ navigateToStepId, handleNavigateMode, isNavigateMode }) => {
    const [dragMode, setDragMode] = useState(false);
    const toggleDragMode = useCallback(() => {
        if (dragMode) {
            setDragMode(false);
            return;
        }
        window.parent.postMessage({ type: POST_MESSAGES_TYPES.DRAG_MODE_ON }, '*');
        setDragMode(true);
    }, [dragMode]);

    const navigateToReviewEvents = () => {
        window.parent.postMessage({ type: POST_MESSAGES_TYPES.CENTER_WINDOW }, '*');
        navigateToStepId(STEP_IDS.REVIEW_EVENTS);
    };

    return (
        <div className={`${styles['header']} ${isNavigateMode ? styles['header--navigate-mode'] : ''}`}>
            <div className={styles['conversion-setup-container']}>
                <div className={styles['icon-container']} onMouseEnter={toggleDragMode}>
                    <SetUpIcon aria-label="Conversion Setup" />
                </div>
                <FormattedMessage
                    id="codeless.conversion.setup.header"
                    className={styles['conversion-setup']}
                    defaultMessage="Conversion Setup"
                />
            </div>
            <div className={styles['codeless-button']}>
                {!isNavigateMode && (
                    <Button
                        size={Button.size.md}
                        variant={Button.variant.outline}
                        data-metrics-event-name={GTM_EVENTS.USABILITY}
                        data-metrics-component="codelessSetupButton"
                        onClick={navigateToReviewEvents}
                    >
                        <ExitAppIcon />
                        <FormattedMessage id="codeless.finish.setup.button" defaultMessage="Finish setup" />
                    </Button>
                )}
                <Button
                    size={Button.size.md}
                    variant={Button.variant.outline}
                    className={styles['header-button']}
                    data-metrics-event-name={GTM_EVENTS.USABILITY}
                    data-metrics-component="codelessMinimizeButton"
                    onClick={handleNavigateMode}
                >
                    {isNavigateMode ? <OpenInFullIcon /> : <CloseFullscreenIcon />}
                </Button>
            </div>
        </div>
    );
};
